import {defaultLocale} from '@i18n/config';

export const inferDate = (value: string | number | Date): Date =>
	value instanceof Date ? value : new Date(value);

export function dateFormatUTC(
	timestamp: string | number | Date,
	locale?: string
): string | undefined {
	if (!timestamp) return undefined;
	const _locale = locale || defaultLocale;
	try {
		return Intl.DateTimeFormat([_locale, defaultLocale], {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			timeZone: 'UTC'
		}).format(inferDate(timestamp));
	} catch (err) {
		if (typeof timestamp === 'string') {
			return dateFormatUTC(Number(timestamp), locale);
		}

		console.error(`Invalid Date Format: ${JSON.stringify(timestamp)}: ${err?.['message']}`);
		return undefined;
	}
}

export function getElapsedTimeInfo(startTimestamp: string): {
	seconds: number;
	relativeTime: string;
} {
	const start = parseInt(startTimestamp, 10);
	if (isNaN(start)) {
		return {seconds: 0, relativeTime: 'invalid timestamp'};
	}

	const now = Date.now();
	const elapsedMs = now - start;
	const seconds = Math.floor(elapsedMs / 1000);

	const rtf = new Intl.RelativeTimeFormat('en', {numeric: 'auto'});

	// Compute the largest unit we can represent
	const units: [Intl.RelativeTimeFormatUnit, number][] = [
		['year', 60 * 60 * 24 * 365],
		['month', 60 * 60 * 24 * 30],
		['day', 60 * 60 * 24],
		['hour', 60 * 60],
		['minute', 60],
		['second', 1]
	];

	for (const [unit, unitSeconds] of units) {
		const delta = Math.floor(seconds / unitSeconds);
		if (Math.abs(delta) >= 1) {
			return {
				seconds,
				relativeTime: rtf.format(-delta, unit)
			};
		}
	}

	return {
		seconds,
		relativeTime: rtf.format(0, 'second')
	};
}
